module.exports = __webpack_public_path__ + "8aad732407874835254cf08b332fa727.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/pos/table/closeBtn_black.png
// module id = 114
// module chunks = 0